<template>
  <NuxtLink
    :to="augmentTo"
    :data-pageTransition="genTransitionName()"
    :target="isExternalUrl(augmentTo) ? '_blank' : undefined"
  >
    <slot />
  </NuxtLink>
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'

const auth = useAuthStore()
const router = useRouter()

const props = withDefaults(
  defineProps<{
    to?: string | RouteLocationRaw | null
    animateNext?: boolean
    animatePrevious?: boolean
  }>(),
  {
    animateNext: false,
    animatePrevious: false,
  },
)

const augmentTo = computed(() => {
  if (!props.to || isExternalUrl(props.to)) return props.to ?? ''

  const location = router.resolve(props.to)

  // inject class into route if there's multiple
  if (
    location.matched?.[location.matched.length - 1]?.path.includes(':class')
  ) {
    if (auth.staff?.school_classes && auth.staff.school_classes.length > 1) {
      if (!location.params.class) location.params.class = auth.schoolClass.slug
    }
  }

  return location
})

const isExternalUrl = (url: RouteLocationRaw) => {
  if (typeof url !== 'string') return false

  return url.startsWith('http')
}

function genTransitionName() {
  if (props.animateNext) {
    return 'next-page'
  }
  if (props.animatePrevious) {
    return 'previous-page'
  }

  return 'default-page'
}
</script>
